import type { AllRouteEndpoints } from "../routeTypes";

export const engagementWebhookTemplatesDuplicateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/webhook_templates/:id",
  "/engagement/webhook_templates",
];
